import React, { ErrorInfo, ReactNode } from 'react';
import { Trans } from 'react-i18next';
import * as Sentry from '@sentry/browser';
import { IoRefresh, IoWarningOutline } from 'react-icons/io5';

interface ErrorBoundaryProps {
  children: ReactNode;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, { hasError: boolean }> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, errorInfo: any) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });
  }

  override render() {
    if (this.state.hasError) {
      return (
        <div className="w-full min-h-[80vh] flex flex-col items-center justify-center ">
          <div className="text-sm flex flex-col items-center bg-light-default text-gray-900 mx-3 px-5 md:px-32 py-10 text-center rounded-md">
            <IoWarningOutline style={{ fontSize: '56px' }} className="my-3 opacity-60" />
            <h2>
              Oops! <Trans>something-went-wrong</Trans>
            </h2>
            <p>
              <Trans>sorry-an-expected-error-occurred</Trans>
            </p>
            <p>
              <Trans>errorBoundary.part1</Trans>
              <a className="underline" href="mailto:customers@carlito-app.com">
                <Trans>errorBoundary.part2</Trans>
              </a>{' '}
              <Trans>errorBoundary.part3</Trans>
            </p>
            <button
              className="mx-auto flex  items-center gap-x-2 mt-4 px-4 py-2 bg-red-700 text-white rounded-md"
              onClick={() => window.location.reload()}
            >
              <IoRefresh />
              <span>Try Again</span>
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
